import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-user-proof',
  templateUrl: './user-proof.component.html',
  styleUrls: ['./user-proof.component.scss'],
})
export class UserProofComponent implements OnInit {
  @Input() userId: any = undefined;
  public user = undefined;
  public send = true;

  constructor(
    private httpSv: HttpService,
    private modalController: ModalController
  ) { }

  async ngOnInit() {
    const body = {
      view: 1,
      id: this.userId
    }

    const res: any = await this.httpSv.itemIndex('paymentProof', '', { id: body.id }, 'show');
    this.user = res.data;

    await this.httpSv.itemAction(body, 'paymentProof', 'update' );
  }

  close(){
    this.modalController.dismiss(true);
  }

  async approve(approve){

    const body = {
      state: approve ? 1 : 2,
      view: 1,
      id: this.user.id,
      send: this.send
    }

    const res = await this.httpSv.itemAction(body, 'paymentProof', 'update' );
    if(res.status){
      this.modalController.dismiss(true);
    }

  }
  
}
